import React, { useState, useEffect, useRef } from "react";
import ReactSelect from "react-select";
import ReactSelectNew from "./React_Select/ReactSelectNew";

const ReportCustomFilter = React.forwardRef((props, ref) => {
  console.log(props, 2324324243242);
  const [selectedOption, setSelectedOption] = useState([]);
  const selectRef = useRef(null);

  const customStyles = {
    option: (provided) => ({
      ...provided,
      wordBreak: "break-all",
    }),
    control: (styles) => ({
      ...styles,
      fontSize: "12px",
      textAlign: "left",
      boxShadow: "none",
    }),
    menu: () => ({
      boxShadow: "none",
      marginTop: "10px",
    }),
    menuList: (style) => ({
      ...style,
      maxHeight: props.className === "children" ? 180 : 300,
    }),
  };

  useEffect(() => {
    props.filterChangedCallback(); // Notify AG Grid when the filter changes
  }, [selectedOption]);

  // Checks if the row should be filtered
  const doesFilterPass = (params) => {
    const fieldValue = params.data?.[props.column.colId]; // Get value from row data

    return selectedOption?.[props.column.colId]?.length
      ? selectedOption?.[props.column.colId]?.includes(fieldValue)
      : true;
  };

  // Determines if the filter is active
  const isFilterActive = () => selectedOption !== null;

  // Handles dropdown selection
  const handleFilterChange = (option, field) => {
    console.log(field, option, 234234324324);
    let newopt = [...option.map((it) => it.value)];

    let obj = {
      [field]: newopt,
    };
    props.filterCheckforanyvalue(newopt, field);
    setSelectedOption(obj);
  };

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        props.api.onFilterChanged();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // AG Grid methods for setting and getting filter state
  const getModel = () =>
    selectedOption ? { value: selectedOption.value } : null;
  const setModel = (model) => {
    setSelectedOption(
      model ? { value: model.value, label: model.label } : null
    );
  };

  React.useImperativeHandle(ref, () => ({
    doesFilterPass,
    isFilterActive,
    getModel,
    setModel,
  }));

  const { field_type, headerName, options, field } = props.colDef;
  if (field_type === "select") {
    console.log(props, 234234324234);
    const newOptions = options.map((it) => ({ label: it.value, value: it.id }));
    return (
      <div className="filterdiv_parent" ref={selectRef}>
        <ReactSelectNew
          statusChangehandler={handleFilterChange}
          field={field}
          data={selectedOption}
          options={newOptions}
        />
      </div>
    );
  }

  return null; // If field type is not "select", return nothing
});

export default ReportCustomFilter;
